import {Injectable} from '@angular/core';
import {StorageService} from "../storage/storage.service";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";

@Injectable()
export class LanguageService {

    private currentLanguage = 'en';
    private languageSubject = new BehaviorSubject<string>('en');
    public language: Observable<string>;

    constructor(private storageService: StorageService) {
        this.language = this.languageSubject.asObservable();
        let curLan = this.storageService.get('LANG');
        if (curLan) {
            this.setCurrentLanguage(curLan);
        }
    }

    public getCurrentLanguage() {
        return this.currentLanguage;
    }

    public setCurrentLanguage(key) {
        this.currentLanguage = key;
        this.languageSubject.next(key);
        this.storageService.set('LANG', key);
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/services/language/language.service.ts